export default {
  common: {
    nav: {
      home: "Nyumbani",
      find_offer_help: "Tafuta / Toa msaada",
      celebrate: "Sherehekea maisha",
      family_tree: "Mti wa familia",
      events: "Matukio",
      civic_reports: "Ripoti za kiraia",
      neighborhood_pulse: "Mapigo ya jirani",
      weather: "Hali ya hewa",
      nature: "Asili",
      marketplace: "Soko",
      news: "Habari",
      causes: "Malengo",
      more: "Zaidi",
    },
    header: { sign_in: "Ingia", join: "Jiunge na Social Pulse", language: "Lugha", search: "Tafuta" },
    tagline: "Kuunganisha jamii · Kuwezesha maisha · Kujenga mtaji wa kijamii",
    locality: { viewing_from: "Unatazama kutoka", change: "Badilisha", set_your_location: "Weka mahali pako" },
    news: { title: "Muhtasari wako wa kila siku.", play_briefing: "Cheza muhtasari wa kila siku", listen: "Sikiliza", translate: "Tafsiri" },
  },
};
